import * as types from '../actions/types';

const initialState = {
  isError: false,
  data: {}
};

const feedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_AVAILABLE_FEEDBACK_FLEX_QUESTION_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.GET_AVAILABLE_FEEDBACK_FLEX_QUESTION_SUCCEEDED:
      return {
        ...state,
        error: null,
        data: action.data.data || {}
      };
    case types.GET_AVAILABLE_FEEDBACK_FLEX_QUESTION_FAILED:
      return {
        ...state,
        isError: true,
        error: action.error
      };
    default:
      return state;
  }
};

export default feedbackReducer;
